module.exports = __webpack_public_path__ + "media/images/flags/1x1/nor-db1fb6d68550fbb862d141cf576d22c7.svg";